import { SEND_REPORT_FORMATS, SCHEDULED_REPORT_FORMATS, SUPPORTED_REPORT_FORMATS } from '~/app_constants';

export default {
  computed: {
    supportedFormats() {
      return SUPPORTED_REPORT_FORMATS[this.report] || SUPPORTED_REPORT_FORMATS.default;
    },
    sendReportFormatOptions() {
      return SEND_REPORT_FORMATS.filter(({ key }) => this.supportedFormats.includes(key));
    },
    scheduledReportFormatOptions() {
      return SCHEDULED_REPORT_FORMATS.filter(({ key }) => this.supportedFormats.includes(key));
    },
    sendReportFormatOptionIds() {
      return this.sendReportFormatOptions.map(({ id }) => id);
    },
    scheduledReportFormatOptionIds() {
      return this.scheduledReportFormatOptions.map(({ id }) => id);
    },
    csvDisabled() {
      return !this.supportedFormats.includes('csv');
    },
    pdfDisabled() {
      return !this.supportedFormats.includes('pdf');
    },
  },
};
